/* eslint-disable quotes */
import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'
import { Box, Button } from '@chakra-ui/react'
import BackButton from 'components/Button/BackButton'
import { useSelector, useDispatch } from 'react-redux'
import { useForm, useFieldArray, useWatch, Controller } from 'react-hook-form'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import { useTranslation } from 'react-i18next'
import DiagramRenderingComponent from '../../../../components/Diagram/Function/DiagramRenderingComponent'
import RGL, { WidthProvider } from 'react-grid-layout'
import { useParams, useHistory, Link } from 'react-router-dom'
import * as actions from '../../../../redux/actions'
import api from '../../../../util/api'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

// Create For Test New scada.
export default function OrderDiagramEdit() {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [currentGroup, setcurrentGroup] = useState()
  const [priority, setPriority] = useState()
  const [priDiagram, setPriDiagram] = useState()
  const params = useParams()
  const me = useSelector((state) => state.me)
  const allStations = useSelector((state) => state.station)
  const [currentStation, setCurrentStation] = useState()
  const dispatch = useDispatch()
  const ReactGridLayout = WidthProvider(RGL)
  const [layout, setLayout] = useState()
  const [Sg, setSG] = useState([])
  const { control, watch, setValue, handleSubmit } = useForm({
    defaultValues: {},
  })

  const { fields } = useFieldArray({
    control,
    name: 'diagram',
  })

  useEffect(() => {
    const fetchStationData = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/station/${params.stationId}`
        )
        console.log('Request Server to Get Station Data')
        if (res.data) {
          setCurrentStation(res.data)
          setIsLoading(true)
        }
      } catch (error) {
        console.error('Error fetching station data:', error)
      }
    }

    fetchStationData()
  }, [params.stationId, params.groupId])

  // useEffect(() => {
  //   api
  //     .get(process.env.REACT_APP_API_URL + '/station/' + params.stationId)
  //     .then((res) => {
  //       console.log('Request Server to Get an Stations')
  //       if (res.data) {
  //         setCurrentStation(res.data)
  //         setIsLoading(true)
  //       }
  //     })

  //   return () => {}
  // }, [params])

  useEffect(() => {
    if (allStations?.arr?.length) {
      const tempStation = _.find(
        allStations.arr,
        (station) => station._id === params.stationId
      )
      setCurrentStation(tempStation)
    }
  }, [params.stationId, params.groupId])

  useEffect(() => {
    if (currentStation) {
      const tempGroup = _.find(
        currentStation.groups,
        (group) => group._id === params.groupId
      )
      setcurrentGroup(tempGroup)

      const tempPriority = _.find(
        currentStation.priority,
        (prior) => prior.role === me.role
      )
      setPriority(tempPriority)

      if (tempPriority) {
        const orderedDiagrams = _.compact(
          _.map(tempPriority.diagram, (diagramId) =>
            _.find(currentStation.diagrams, (dia) => dia._id === diagramId)
          )
        )
        setPriDiagram(orderedDiagrams)
      }
    }
  }, [currentStation, params.stationId, params.groupId])

  const saveOrdered = async (data) => {
    let confirm = window.confirm('ยืนยันการจัดเรียง')
    const diagramStation = currentStation.diagrams
    _.map(layout, (SSDia) => {
      _.map(currentStation.diagrams, (SDiagram, int) => {
        if (SDiagram._id === SSDia.i) {
          diagramStation[int].axisX = SSDia.x
          diagramStation[int].axisY = SSDia.y
          diagramStation[int].width = SSDia.w
          diagramStation[int].height = SSDia.h
        }
      })
    })

    if (confirm) {
      const payload = { diagrams: diagramStation }
      await dispatch(actions.stationPut(params?.stationId, payload))
      await dispatch(actions.stationAll())
      //   history.goBack()
      // console.log(
      //   'New Rendered ',
      //   currentStation.diagrams,
      //   layout,
      //   diagramStation
      // )
    }
  }

  useEffect(() => {
    if (currentGroup && priDiagram.length > 0) {
      const tempSG = _.filter(priDiagram, (gg) =>
        currentGroup.diagram.includes(gg._id)
      )
      setSG(tempSG)
      setValue('diagram', tempSG)
      const layoutSet = tempSG.map((dia, index) => ({
        i: dia._id.toString(),
        x: dia.axisX,
        y: dia.axisY,
        w: dia.width,
        h: dia.height,
      }))
      setLayout(layoutSet)
    }
  }, [currentGroup, priDiagram, params])
  // console.log('SG', layout)

  const genDiagramList = () => {
    return (
      <div>
        <ReactGridLayout
          className="layout"
          layout={layout}
          onLayoutChange={(e) => {
            setLayout(e)
          }}
          cols={18}
          rowHeight={50}
          width={800}
          isResizable={true}
          isDraggable={true}
        >
          {_.map(layout, (item, i) =>
            Sg.length !== 0 ? (
              <div
                key={item.i}
                className={`${item?.bgColor} grid grid-cols-1 text-center border cursor-move`}
              >
                {Sg[i]?.diagramName}
                <DiagramRenderingComponent
                  layout={item}
                  attributeData={Sg[i]?.attribute[0]}
                  stationData={currentStation}
                  diagramData={Sg[i]}
                  display={false}
                />
              </div>
            ) : (
              <></>
            )
          )}
        </ReactGridLayout>
      </div>
    )
  }

  if (currentStation && isLoading) {
    return (
      <div>
        <div className=" flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
          <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex-grow flex-1">
                <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
                  {t('setting.systemManagement')}
                </h6>
                <h2 className="text-gray-800 text-2xl font-bold font-sans">
                  {t('arrangement.manageFlowchartArrangement')}{' '}
                  {currentStation.name}
                </h2>
              </div>
            </div>
            <Button>
              <BackButton />
            </Button>
          </div>
          <form onSubmit={handleSubmit(saveOrdered)}>
            <div className="flex justify-between p-2">
              <h2 className="text-gray-800 text-xl px-10 font-bold font-sans">
                กลุ่ม {currentGroup?.groupName}
              </h2>
              <div className="flex justify-items-start">
                {' '}
                <Button
                  colorScheme="green"
                  variant="solid"
                  size="sm"
                  type="submit"
                >
                  {t('utility.saveArrangement')}
                </Button>
              </div>
            </div>
            <div className="bg-gray-500  p-2 m-2 overflow-auto">
              <div className="h-4/6 w-1280">{genDiagramList()}</div>
            </div>
          </form>
        </div>
      </div>
    )
  } else {
    return <SpinnerLoading />
  }
}
